<template lang="pug">
include /mixins
+b.ticket-management-not-found
  +e.icon-wrap
    +e.icon.SVG(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none')
      path(d='M11.1336 3.5C11.5185 2.83333 12.4808 2.83333 12.8657 3.5L21.5259 18.5C21.9108 19.1667 21.4297 20 20.6599 20H3.33938C2.56958 20 2.08846 19.1667 2.47336 18.5L11.1336 3.5Z' stroke='#FF7A00' stroke-width='1.3')
      path(d='M11.9102 14.0898C11.8769 14.0898 11.8477 14.0619 11.8477 14.0264L11.8477 7.65723C11.8491 7.64241 11.8555 7.6286 11.8662 7.61816C11.878 7.60685 11.8938 7.60059 11.9102 7.60059C11.9182 7.60059 11.9262 7.60156 11.9336 7.60449L11.9541 7.61816C11.9648 7.6286 11.9712 7.64241 11.9727 7.65723L11.9727 14.0273C11.9727 14.061 11.9458 14.0896 11.9102 14.0898ZM11.8828 17.5332C11.8078 17.5331 11.7357 17.5032 11.6826 17.4502C11.6295 17.397 11.5996 17.3242 11.5996 17.249C11.5997 17.1739 11.6295 17.1019 11.6826 17.0488C11.7357 16.9957 11.8077 16.9659 11.8828 16.9658C11.958 16.9658 12.0308 16.9957 12.084 17.0488C12.137 17.1019 12.1669 17.174 12.167 17.249C12.167 17.3242 12.1371 17.397 12.084 17.4502C12.0308 17.5034 11.958 17.5332 11.8828 17.5332Z' fill='#FF7A00' stroke='#FF7A00' stroke-width='1.2')
  +e.title.P {{ _('По Вашему номеру телефона билетов не найдено') }}
  +e.text.P {{ _('Проверьте указанный номер и попробуйте еще раз') }}
  +e.label.P {{ _('Указанный номер') }}
  +e.phone.P {{ phone }}
  +e.btn
    +b.tt-button--auto(
      :disabled='isLoad'
      @click.prevent='clearCookies'
    )
      +e.title.P {{ _('Проверить еще раз') }}

</template>

<script>
import { checkTickets } from '@api/ticket_management.service'

import { TOTIS_2_BUYER_TOKEN, TOTIS_2_BUYER_ID_TOKEN } from '@/app'
import { getCookie, removeCookie } from '@utils/cookies'

export default {
  name: 'TicketCheck',
  props: {
    phone: {
      type: String,
    },
    check: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoad: false,
    }
  },
  methods: {
    clearCookies() {
      removeCookie(TOTIS_2_BUYER_TOKEN)
      removeCookie(TOTIS_2_BUYER_ID_TOKEN)
      this.check()
    },
  },
}
</script>
